import { AddOnProductType } from "@stores/addons/types";
import { ICreatePurchaseAddOn } from "@stores/purchases/types";
import { ADD_ONS_DESCRIPTORS, getDescriptor } from "./registry";
import { IPurchaseContext, IRemoveAddOn, IUpsertContext } from "./types";

export const getRemoveAddonPayload = (
  ctx: IPurchaseContext,
  type: AddOnProductType,
): IRemoveAddOn[] => {
  if (!ctx.subscribedByType[type]) {
    return [];
  }

  const payload: IRemoveAddOn[] = [{ product_type: type }];

  ADD_ONS_DESCRIPTORS.forEach((descriptor) => {
    const requiresAnyOf = descriptor.requires?.anyOf;

    if (!requiresAnyOf?.includes(type)) {
      return;
    }

    const remained = requiresAnyOf.filter(
      (other) => ctx.subscribedByType[other] && other !== type,
    );

    if (remained.length > 0) {
      return;
    }

    payload.push(...getRemoveAddonPayload(ctx, descriptor.productType));
  });

  return payload;
};

export const getUpsertAddOnsFor = (
  ctx: IUpsertContext,
  type: AddOnProductType,
  units?: number,
): ICreatePurchaseAddOn[] => {
  const descriptor = getDescriptor(type);

  if (!descriptor) {
    return [];
  }

  if (descriptor.kind === "prepaid") {
    return units === undefined
      ? []
      : (descriptor.getUpsertAddOns?.(ctx, units) ?? []);
  }

  return descriptor.getUpsertAddOns?.(ctx) ?? [];
};
